import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, IconButton, Typography } from "@mui/material";
import { Modal } from "app/components/Modal";
import FileInput from "app/components/InputFile";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { selectUser } from "store/global/authPermission/selector";

import {
  selectDocumentUploadError,
  selectDocumentUploadFile,
  selectIsAddDocumentModalOpen,
} from "../../../../redux/selector";
import { customersActions } from "../../../../redux/slice";
import { useStyles } from "./styles";

const P = "CUSTOMERS.DETAILS.DOCUMENTS.MODAL";

const formatToday = () => {
  const now = new Date();
  const day = String(now.getDate()).padStart(2, "0");
  const month = String(now.getMonth() + 1).padStart(2, "0");
  return `${day}/${month}/${now.getFullYear()}`;
};

const AddDocumentModal = () => {
  const { t } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();
  const open = useSelector(selectIsAddDocumentModalOpen);
  const user = useSelector(selectUser);
  const file = useSelector(selectDocumentUploadFile);
  const error = useSelector(selectDocumentUploadError);

  const isValid = Boolean(file);

  const resetForm = () => {
    dispatch(customersActions.resetAddDocumentForm());
  };

  const handleClose = () => {
    resetForm();
    dispatch(customersActions.closeAddDocumentModal());
  };

  const handleSubmit = () => {
    if (!file) return;

    const uploadedBy =
      [user?.firstName, user?.lastName].filter(Boolean).join(" ") || "";

    dispatch(
      customersActions.addCustomerDocument({
        id: Date.now(),
        documentName: file.name,
        connectedVehicle: "",
        uploadedBy,
        date: formatToday(),
      })
    );

    resetForm();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box className={styles.modal}>
        <Box className={styles.header}>
          <Typography className={styles.title}>
            {t(`${P}.ADD_TITLE`)}
          </Typography>
          <IconButton
            className={styles.closeButton}
            onClick={handleClose}
            aria-label={t("BUTTONS.CANCEL")}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <Box className={styles.body}>
          <FileInput
            dispatchFileChange={(x) =>
              dispatch(customersActions.setDocumentUploadFile(x))
            }
            dispatchFileError={(x) =>
              dispatch(customersActions.setDocumentUploadError(x))
            }
            file={file}
            error={error}
          />
        </Box>

        <Box className={styles.footer}>
          <Button
            className={styles.cancelButton}
            variant="outlined"
            onClick={handleClose}
          >
            {t("BUTTONS.CANCEL")}
          </Button>
          <Button
            className={styles.addButton}
            variant="contained"
            disableElevation
            disabled={!isValid}
            onClick={handleSubmit}
          >
            {t("BUTTONS.ADD")}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddDocumentModal;
